module.exports = __webpack_public_path__ + "img/delete_icon.26cc4a1b.svg";